import { Button } from "@mui/material";
import BasicTooltip from "../tooltips/BasicTooltip";
/*
사용자 목록 정보
MemberId, MemberName, Email, ApprovalYn, MemberType, Did, ConnectionId, CreatedDate, CreatedBy

*/

export default function Columns4Member (t, handleApproval)
{
    const handleAcction = (memberid, membername) => {
        handleApproval(memberid, membername);
    };

    const columns = [
        {
            field: "RowNum",
            headerName: 'No.',
            flex: 0.3,
            type: 'number',
            headerClassName: 'super-app-theme--header',
            headerAlign: 'center',
            align: 'center',
            hideable: false,
            hide: false,
            sortable: false,
            resizable: false,
            editable: false,
        },
        {
            field: "RegFailYn",
            headerName: t('field.regfailyn'),
            flex: 0.4,
            type: 'string',
            headerClassName: 'super-app-theme--header',
            headerAlign: 'center',
            align: 'center',
            hideable: false,
            hide: false,
            sortable: false,
            resizable: false,
            editable: false,
        },
        {
            field: "ApprovalYn",
            headerName: t('field.approvalyn'),
            flex: 0.5,
            type: 'string',
            headerClassName: 'super-app-theme--header',
            headerAlign: 'center',
            align: 'center',
            hideable: false,
            hide: false,
            sortable: false,
            resizable: false,
            editable: false,
            renderCell: (params) => {
                return (
                    <strong>
                        {(params.value !== undefined && params.value === null && params.row.RegFailYn !== 'Y') ?  
                        <Button variant="contained" color="secondary" size="small" style={{maxWidth: '60px', maxHeight: '28px', minWidth: '60px', minHeight: '28px'}} onClick={()=>handleAcction(params.row.MemberId, params.row.MemberName)} >{t('button.confirm')}</Button>:params.value||'X' }
                    </strong>
                );
            }
        },
        {
            field: "CompanyId",
            headerName: t('field.companyid'),
            flex: 0.5,
            with: 0,
            type: 'number',
            headerClassName: 'super-app-theme--header',
            headerAlign: 'center',
            align: 'center',
            hideable: false,
            hide: false,
            sortable: false,
            resizable: false,
            editable: false,
        },
        {
            field: "RegNo",
            headerName: t('field.regno'),
            flex: 0.5,
            with: 0,
            type: 'number',
            headerClassName: 'super-app-theme--header',
            headerAlign: 'center',
            align: 'center',
            hideable: false,
            hide: false,
            sortable: false,
            resizable: false,
            editable: false,
        },
        {
            field: "CompanyName",
            headerName: t('field.companyname'),
            flex: 1,
            with: 0,
            type: 'string',
            headerClassName: 'super-app-theme--header',
            headerAlign: 'center',
            align: 'center',
            hide: false,
            sortable: false,
            resizable: false,
            editable: false,
        },
        {
            field: "MemberName",
            headerName: t('field.membername'),
            flex: 1,
            type: 'string',
            headerClassName: 'super-app-theme--header',
            headerAlign: 'center',
            align: 'center',
            hideable: false,
            hide: false,
            sortable: false,
            resizable: false,
            editable: false,
            // valueGetter: ({ value }) => value || "-",
        },
        {
            field: "Email",
            headerName: t('field.email'),
            flex: 1.5,
            type: 'string',
            headerClassName: 'super-app-theme--header',
            headerAlign: 'center',
            hideable: false,
            hide: false,
            sortable: false,
            resizable: false,
            editable: false,
            renderCell: (params) => (
                <BasicTooltip title={params.row.Email} placement="right-end" />
            ),
            valueGetter: ({ value }) => value || "-",
        },
        {
            field: "MemberId",
            headerName: t('field.memberid'),
            flex: 0.7,
            type: 'string',
            headerClassName: 'super-app-theme--header',
            headerAlign: 'center',
            align: 'center',
            hideable: false,
            hide: false,
            sortable: false,
            resizable: false,
            editable: false,
        }
    ];

    return columns;
};